export const CalendarViews = {
  day: 'resourceTimeGridDay',
  week: 'timeGridWeek',
  month: 'dayGridMonth',
  timeline: 'resourceTimeline',
  list: 'list',
}

export const CalendarReasonCodes = {
  GCU: {
    code: 'GCU',
    calendar: 'Google',
    reason: 'Google Synched Event'
  },
  OCU: {
    code: 'OCU',
    calendar: 'Outlook',
    reason: 'Outlook Synched Event'
  },
  RAB: {
    code: 'RAB',
    calendar: 'OnSched',
    reason: 'Resource Block'
  },
  BK: {
    code: 'BK',
    calendar: 'OnSched',
    reason: 'OnSched Booked Appointment'
  },
  CN: {
    code: 'CN',
    calendar: 'OnSched',
    reason: 'OnSched Cancelled Appointment'
  },
  RS: {
    code: 'RS',
    calendar: 'OnSched',
    reason: 'OnSched Reservation'
  },
  RE: {
    code: 'RE',
    calendar: 'OnSched',
    reason: 'Rescheduled OnSched Appointment'
  },
  IN: {
    code: 'IN',
    calendar: 'OnSched',
    reason: 'Initial OnSched Appointment'
  },
}
